import React, {useState} from 'react';
import {Modal} from "react-bootstrap";
import {IconClose} from "src/components/icons/IconClose";
import styles from "./WarningDxSyc.module.scss";

import {Button} from 'src/components/common/button/Button';

import { useTranslationService } from 'src/services/TranslationService';
import Input from "../../../common/input/Input";

export const WarningDxSyc = ({
        onContinue,
        onClose,
    }) => {

    const { t } = useTranslationService();

    const [continueDxSyc, setContinueDxSyc] = useState(false);

    return <Modal
        show
        onHide={onClose}
        animated="false"
        className="modal fade in theme-light"
        dialogClassName="modal-md"
        backdropClassName="in"
    >
        <div className="modal-header no-border">
            <span className={styles.title}>{t('new-login.modal-warning-dx-syc.title')}</span>
            <Button variant="no-style" hasIcon className="close" onClick={() => onClose()}>
                <IconClose/>
            </Button>
        </div>
        <div className={styles.modal_body}>
            <div className={styles.content}>
                <p>
                    {t('new-login.modal-warning-dx-syc.description.1')}
                </p>
                <p>
                    {t('new-login.modal-warning-dx-syc.description.2')}
                </p>
                <p className="dx-mb-7">
                    {t('new-login.modal-warning-dx-syc.description.3')}
                </p>
                <div className="d-flex dx-mb-7">
                    <span className={'flex-shrink-0'}>
                        <Input
                            type={'checkbox'}
                            onChange={e => setContinueDxSyc(e.target.checked)}
                        />
                    </span>
                    <span className={'dx-ml-3'}>
                        {t('new-login.modal-warning-dx-syc.accept')}
                    </span>
                </div>
                <div className="d-flex">
                    <Button variant="outline-secondary" rounded className="dx-ml-auto dx-mr-5" onClick={() => onClose()}>
                        {t('new-login.modal-warning-dx-syc.cancel')}
                    </Button>
                    <Button variant="primary-dark" rounded onClick={() => onContinue()} disabled={!continueDxSyc}>
                        {t('new-login.modal-warning-dx-syc.continue')}
                    </Button>
                </div>
            </div>
        </div>
    </Modal>;
};
